<script lang="ts" setup>
import SectionHeadline from '@/components/SectionHeadline.vue'
import FormElement from '@/components/FormElement.vue'
import projectStore from '@/store/ProjectStore'
import formStore from '@/store/FormStore'
import userStore from '@/store/UserStore'
import { computed } from 'vue'
import { ValidatorType } from '@/helper/ValidateDirective'
import ComboBox from '@/components/ComboBox.vue'
import i18n from '@/helper/Translations'

const props = defineProps<{
  validator?: ValidatorType
}>()

const groundTypes = computed(() => {
  return userStore.groundTypes?.map(groundType => ({
    label: i18n.global.t(`step_heating_details.ground_types.${groundType.name}`),
    value: groundType.name
  }))
})

defineExpose({
  validator: props.validator
})
</script>

<template>
  <section class="form__section has--line section--ground-type">
    <div class="form__section-inner">
      <SectionHeadline class="form__title" translation-key="step_heating_details.title_ground_types" />

      <label class="form__checkbox">
        <input v-model="formStore.data.groundTypesEnabled" name="ground-types-enabled" type="checkbox">
        <span class="form__cm" />
        {{ $t('step_heating_details.checkbox_ground_type_label') }}
      </label>

      <transition name="expand">
        <div v-if="formStore.data.groundTypesEnabled" class="row form__row ground-type-data">
          <div class="col-md-6">
            <FormElement
              v-validate="projectStore.projectProperties.groundType.formValidationRule"
              :error="props.validator.groundType?.error"
              :required="projectStore.formPropertyIsRequired('groundType')"
              label-key="step_heating_details.ground_types_label"
            >
              <ComboBox id="ground-types" v-model="formStore.data.groundType" :options="groundTypes" />
            </FormElement>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.ground-type-data {
  margin-top: rem-calc(16);
}
</style>
